import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Divider, Flex, List, Skeleton } from 'antd';
import { FC, useCallback } from 'react';
import { Folder, useFolder, useFolders } from 'services';
import { useActiveFolderId, useIsRootFolder, useSetActiveFolderId } from '../../../store/filepicker.store';
import FilePickerFolderCard from './FilePickerFolderCard.component';

type FoldersListProps = {};

export const FoldersList: FC<FoldersListProps> = () => {
  const activeFolderId = useActiveFolderId();
  const { data: foldersData, isLoading: isLoadingFolders } = useFolders({
    parent_id: activeFolderId,
    is_filepicker: false,
  });

  const setActiveFolder = useSetActiveFolderId();

  const handleOnFolderClick = useCallback(
    (folder: Folder) => {
      setActiveFolder(folder.id, folder.parent_id);
    },
    [setActiveFolder],
  );

  if (isLoadingFolders) {
    return (
      <>
        <Divider />

        <Flex gap={16} style={{ width: '100%', overflowX: 'hidden' }}>
          <Skeleton.Node fullSize active style={{ height: 80, minWidth: 180 }} />
          <Skeleton.Node fullSize active style={{ height: 80, minWidth: 180 }} />
          <Skeleton.Node fullSize active style={{ height: 80, minWidth: 180 }} />
        </Flex>
        <Divider />
      </>
    );
  }

  return (
    <div style={{ marginBottom: '20px' }}>
      {foldersData?.folders?.data && foldersData?.folders?.data?.length > 0 && (
        <List
          grid={{
            gutter: 8,
            xs: 1,
            sm: 2,
            md: 2,
            lg: 3,
            xl: 3,
            xxl: 3,
          }}
          rowKey="id"
          dataSource={foldersData?.folders?.data}
          renderItem={(folder: Folder) => (
            <FilePickerFolderCard folderData={folder} onClick={() => handleOnFolderClick(folder)} />
          )}
        />
      )}
    </div>
  );
};
